import React from "react";
import "../GlobalStyles.css";
import "./DownloadApps.css";
import { isAndroid, isIOS, isDesktop } from "react-device-detect";

function DownloadApps() {
  return (
      <div className={"download-apps-container"}>
        {isIOS && (
            <a href="https://apps.apple.com/gr/app/ant1/id1554790591"
               target="_blank" rel="noreferrer">
              <img src="images/appStore.png" alt="app store logo"/>
            </a>
        )}
        {isAndroid && (
            <a href="https://play.google.com/store/apps/details?id=gr.antenna.ant1"
               target="_blank" rel="noreferrer">
              <img src="images/googlePlay.png" alt="google play logo"/>
            </a>
        )}
        {isDesktop && (
            <>
              <a href="https://apps.apple.com/gr/app/ant1/id1554790591"
                 target="_blank" rel="noreferrer">
                <img src="images/appStore.png" alt="app store logo"/>
              </a>
              <a href="https://play.google.com/store/apps/details?id=gr.antenna.ant1"
                 target="_blank" rel="noreferrer">
                <img src="images/googlePlay.png" alt="google play logo"/>
              </a>
            </>
        )}
      </div>
  );
}

export default DownloadApps;
